import React from 'react';

import { TextField } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

export function NumberEditCell({
  id,
  field,
  value,
  disabled = false,
}: GridRenderEditCellParams & { disabled?: boolean }) {
  const apiRef = useGridApiContext();
  return (
    <TextField
      type="number"
      value={value ?? ''}
      disabled={disabled}
      onChange={(event) => {
        const rawValue = event.target.value;
        apiRef.current.setEditCellValue({
          id,
          field,
          value: rawValue === '' ? undefined : Number(rawValue),
        });
      }}
      inputProps={{ min: 0 }}
      size="small"
      fullWidth
    />
  );
}

export function getProductLabel(value: string, productLabelMap: Map<string, string>) {
  return productLabelMap.get(value) || value;
}
